import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import './eventSlider.css'

// Replace these with your actual event images
import { B1 } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'

// Static fallback — kept for reference. Real featured events (latest, first
// page) come from GET /customer_events/ below.
// const featuredEvents = [
//   {
//     id: 1,
//     date: 'Sun, 10 May, 3:00 PM',
//     title: 'Ghar: An Open Mic for words by Tape A Tale',
//     location: 'Studio 44, Noida',
//     liked: '74%',
//     hosting: '74%',
//     hostedEvents: 9,
//     image: B1,
//   },
//   {
//     id: 2,
//     date: 'Sat, 16 May, 6:30 PM',
//     title: 'Live Music Night with Popular Artists',
//     location: 'Jawahar Lal Nehru Stadium, Delhi',
//     liked: '89%',
//     hosting: '82%',
//     hostedEvents: 15,
//     image: B2,
//   },
//   {
//     id: 3,
//     date: 'Fri, 22 May, 7:00 PM',
//     title: 'The Ultimate Stand-Up Comedy Show',
//     location: 'The Comedy Club, Gurugram',
//     liked: '91%',
//     hosting: '87%',
//     hostedEvents: 21,
//     image: B3,
//   },
// ]

const formatEventDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value.replace(' ', 'T'))
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('en-US', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}

const EventSlider = () => {
  const navigate = useNavigate()
  const swiperRef = useRef(null)
  const [featuredEvents, setFeaturedEvents] = useState([])

  useEffect(() => {
    service
      .get(endpoints.customerEvents.list, {}, { silent: true })
      .then(({ data }) => {
        const events = (data.data || []).map((event) => ({
          id: event.id,
          date: formatEventDateTime(event.start_date_time),
          title: event.name,
          location: event.venue_name,
          image: event.banner_image || event.cover_image || B1,
        }))
        setFeaturedEvents(events)
      })
      .catch(() => {})
  }, [])

  const handleBookTicket = (event) => {
    navigate(`/event-detail/${event.id}`)
  }

  return (
    <section className="featuredEvent">
      <div className='container position-relative'>
      <button
        type="button"
        className="featuredEvent__arrow featuredEvent__arrow--left"
        aria-label="Previous event"
        onClick={() => swiperRef.current?.slidePrev()}
      >
        ←
      </button>

      <button
        type="button"
        className="featuredEvent__arrow featuredEvent__arrow--right"
        aria-label="Next event"
        onClick={() => swiperRef.current?.slideNext()}
      >
        →
      </button>

      <div className="featuredEvent__container">
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          loop={featuredEvents.length > 1}
          speed={700}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{
            clickable: true,
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper
          }}
          className="featuredEvent__swiper"
        >
          {featuredEvents.map((event) => (
            <SwiperSlide key={event.id}>
              <div className="featuredEvent__slide">
                <div className="featuredEvent__content">
                  <p className="featuredEvent__date">{event.date}</p>

                  <h2 className="featuredEvent__title">
                    {event.title}
                  </h2>

                  <p className="featuredEvent__location">
                    {event.location}
                  </p>

                  {/* No ratings/hosting-stats fields on GET /customer_events/ — nothing real to show here. */}

                  <button type='button' className='commonBtn cruiseSearchPill__btn mt-4 eventBk' onClick={() => handleBookTicket(event)}>Book Ticket</button>

                </div>

                <div className="featuredEvent__imageWrapper">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="featuredEvent__image"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      </div>
    </section>
  )
}

export default EventSlider;